import { useState, useEffect } from 'react';
import { 
  checkForSavedMatch, 
  restoreSavedMatch,
  PersistedMatchData 
} from './useMatchPersistence';

interface UseMatchRecoveryReturn {
  savedMatch: PersistedMatchData | null;
  showRecoveryModal: boolean;
  handleRestoreMatch: () => void;
  handleStartNewMatch: () => void;
  setSavedMatch: (match: PersistedMatchData | null) => void;
  setShowRecoveryModal: (show: boolean) => void;
}

interface UseMatchRecoveryProps {
  isInitialized: boolean;
  clearSavedMatch: () => void;
  onRestoreMatch: (restoredState: any) => void;
  onStartNewMatch: () => void;
}

/**
 * Hook pour gérer la récupération de match sauvegardé
 * Code extrait d'App.tsx sans modification
 */
export function useMatchRecovery({
  isInitialized,
  clearSavedMatch,
  onRestoreMatch,
  onStartNewMatch
}: UseMatchRecoveryProps): UseMatchRecoveryReturn {
  
  // État de récupération (code exact d'App.tsx)
  const [savedMatch, setSavedMatch] = useState<PersistedMatchData | null>(null);
  const [showRecoveryModal, setShowRecoveryModal] = useState(false);

  // Vérifier s'il y a un match sauvegardé au démarrage (code exact d'App.tsx)
  useEffect(() => {
    const saved = checkForSavedMatch();
    if (saved && !isInitialized) {
      setSavedMatch(saved);
      setShowRecoveryModal(true);
    }
  }, [isInitialized]);

  // Handlers pour la récupération (code exact d'App.tsx)
  const handleRestoreMatch = () => {
    const restored = restoreSavedMatch();
    if (restored) {
      onRestoreMatch(restored);
      setShowRecoveryModal(false);
      setSavedMatch(null);
    }
  };

  const handleStartNewMatch = () => {
    clearSavedMatch();
    setShowRecoveryModal(false);
    setSavedMatch(null);
    onStartNewMatch();
  };

  return {
    savedMatch,
    showRecoveryModal,
    handleRestoreMatch,
    handleStartNewMatch,
    setSavedMatch,
    setShowRecoveryModal
  };
}